import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { errorNotify } from 'app/store/common-effects/notifier.effects';
import { navigate } from 'app/store/common-effects/router.effects';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RecoveryInviteGuard {
  constructor(private store$: Store) {
  }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const recoveryId = next.queryParams.recoveryId;

    if (!recoveryId) {
      this.store$.dispatch(errorNotify({ message: 'ERROR.invalid_recovery_link' }));
      this.store$.dispatch(navigate({ path: ['login'] }));
      return of(false);
    }

    return of(true);
  }
}
